import {Component, Input, OnInit} from '@angular/core';
import {Shipment} from '../../../domain/shipment';

@Component({
    selector: 'app-shipment-item',
    templateUrl: './shipment-item.component.html',
    styleUrls: ['./shipment-item.component.css'],
    standalone: false
})
export class ShipmentItemComponent implements OnInit {
  @Input() shipment: Shipment;

  constructor() {
  }

  ngOnInit(): void {
  }
}
